export default "__VITE_ASSET__Dk743D_V__"